import { render } from "./GeneralSettings.vue?vue&type=template&id=acf32c4c&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=acf32c4c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf32c4c"]])

export default __exports__